import React from "react";
import styled from "styled-components";
import "@fontsource/ibm-plex-mono";

const CardWrapper = styled.div`
  height: 120px;
  width: 120px;
  position: relative;

  .overlap-group {
    background-color: #cbded3;
    border-radius: 15px;
    height: 120px;
    position: relative;
    width: 120px;
  }

  .image {
    height: 56px;
    position: absolute;
    top: 23px;
    left: 50%;
    transform: translateX(-50%);
  }

  .label {
    color: #3b6255;
    font-family: "IBM Plex Mono", Helvetica;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    position: absolute;
    top: 85px;
    width: 100%;
  }
`;

interface CategoryCardProps {
  imageSrc: string;
  label: string;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({ imageSrc, label }) => (
  <CardWrapper>
    <div className="overlap-group">
      <img className="image" alt={label} src={imageSrc} />
      <div className="label">{label}</div>
    </div>
  </CardWrapper>
);
